import easyBuyServices from '../services/EasyBuyServices'

// ── Helpers ──────────────────────────────────────────────────────────────────

const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())

const isValidCode = (code) =>
  /^[a-z0-9-]+$/.test(code)   // solo minúsculas, números y guiones

/**
 * Valida los campos del formulario en el cliente antes de enviarlo.
 *
 * @returns {{ error: boolean, field?: string, message?: string }}
 */
const validateForm = (data) => {
  if (!data.trade_name?.trim()) {
    return { error: true, field: 'trade_name', message: 'Ingresa el nombre de tu tienda.' }
  }

  if (data.code && !isValidCode(data.code)) {
    return { error: true, field: 'code', message: 'Solo letras minúsculas, números y guiones (-).' }
  }

  if (!data.identification?.trim()) {
    return { error: true, field: 'identification', message: 'Ingresa tu RUC o cédula.' }
  }

  if (!/^\d+$/.test(data.identification)) {
    return { error: true, field: 'identification', message: 'El RUC/cédula solo debe contener números.' }
  }

  if (data.identification.length !== 10 && data.identification.length !== 13) {
    return { error: true, field: 'identification', message: 'Debe tener 10 dígitos (cédula) o 13 (RUC).' }
  }

  if (!data.owner?.first_name?.trim()) {
    return { error: true, field: 'owner.first_name', message: 'Ingresa tu nombre.' }
  }

  if (!data.owner?.email?.trim()) {
    return { error: true, field: 'owner.email', message: 'Ingresa tu correo electrónico.' }
  }

  if (!isValidEmail(data.owner.email)) {
    return { error: true, field: 'owner.email', message: 'Ingresa un correo válido.' }
  }

  return { error: false }
}

/**
 * Construye el payload que espera el backend a partir del estado del formulario.
 */
const buildPayload = (form, marketplaceEnabled) => ({
  trade_name:    form.tradeName.trim(),
  code:          form.code.trim() || undefined,
  identification: form.identification.trim(),
  email:         form.ownerEmail.trim(),
  phone:         form.phone.trim() || undefined,
  billing_cycle: 'monthly',
  owner: {
    email:      form.ownerEmail.trim(),
    first_name: form.ownerFirstName.trim(),
    last_name:  form.ownerLastName.trim() || undefined,
  },
})

/**
 * Punto de entrada principal.
 * Valida, construye el payload y llama al servicio.
 */
const registerTenantLogic = async (form, marketplaceEnabled) => {
  const payload = buildPayload(form, marketplaceEnabled)
  const validation = validateForm(payload)
  if (validation.error) {
    return {
      error: true,
      status: 0,
      fieldErrors: { [validation.field]: validation.message },
      message: validation.message,
      variant: 'warning',
    }
  }

  return await easyBuyServices.registerTenant(payload)
}

const easyBuyLogic = { registerTenantLogic }
export default easyBuyLogic
